import { Component, OnChanges, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
  ],
  selector: 'file-upload-status',
  styleUrls: ['./file-upload-status.component.scss'],
  templateUrl: './file-upload-status.component.html',
})
export class FileUploadStatusComponent implements OnChanges {
  readonly progressBarItem = input<any>();
  readonly progress = input(0);
  readonly cancelUploadId = output<string>();

  ngOnChanges() {
    this.progressBarItem().newUpload = true;
  }

  onCancelUpload(document: { id: string }) {
    this.cancelUploadId.emit(document.id);
  }
}
